import React from 'react';
import { connect } from 'react-redux';
import DeleteForm from 'components/event/DeleteForm';
import StyledModalHeader from 'components/modal/StyledModalHeader';
import StyledModalBody from 'components/modal/StyledModalBody';

import { deleteEvent } from 'actions/Event';

import { clearModal } from 'actions';

import { Modal } from 'reactstrap';

const DeleteEventModal = ({ modalOpen, deleteEvent, event, clearModal }) => {
  /**
   * Shouldn't show the form if there is no event object
   */
  const readyToShowForm = event ? true : false;

  const cancelDeletingEvent = clearModal.bind(null, 'EVENT_DELETE_FORM');

  return (
    <Modal isOpen={modalOpen} toggle={cancelDeletingEvent}>
      <StyledModalHeader toggle={cancelDeletingEvent}>
        Delete event
      </StyledModalHeader>
      <StyledModalBody>
        {readyToShowForm && (
          <DeleteForm
            event={event}
            onSubmit={(evnt) => {
              deleteEvent(evnt);
              cancelDeletingEvent();
            }}
            onCancel={cancelDeletingEvent}
          />
        )}
      </StyledModalBody>
    </Modal>
  );
};

export default connect(
  (state) => {
    const { modal } = state;

    return {
      modalOpen: modal && modal.type === 'EVENT_DELETE_FORM',
      event: modal && modal.initialValue,
    };
  },
  {
    deleteEvent,
    clearModal,
  },
)(DeleteEventModal);
